import { render, staticRenderFns } from "./SendLogs.vue?vue&type=template&id=606cb032&scoped=true"
import script from "./SendLogs.vue?vue&type=script&lang=js"
export * from "./SendLogs.vue?vue&type=script&lang=js"
import style0 from "./SendLogs.vue?vue&type=style&index=0&id=606cb032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606cb032",
  null
  
)

export default component.exports